export default [
    {
        path: '/home',
        component: () => import('@/views/home/index.vue'),
        meta: {
            title: '报告列表',
        },
    },
    {
        path: '/home-woman',
        component: () => import('@/views/home/woman.vue'),
        meta: {
            title: '报告列表',
        },
    },
]
